"use client";

import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { trackGoogleAdsContactConversion } from "@/lib/google-ads";

type Props = Omit<ComponentPropsWithoutRef<"a">, "href" | "onClick"> & {
    href: string;
    children: ReactNode;
};

export default function TrackedPhoneLink({ href, children, ...props }: Props) {
    return (
        <a
            href={href}
            onClick={() => trackGoogleAdsContactConversion()}
            {...props}
        >
            {children}
        </a>
    );
}
